import * as React from "react";
const SvgFiRrWindTurbine = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M21.684 13.762c-1.37-1.095-3.907-3.071-6.064-4.468-.289-2.559-.925-5.708-1.293-7.42A2.36 2.36 0 0 0 12.001 0a2.36 2.36 0 0 0-2.326 1.874C9.307 3.587 8.67 6.736 8.382 9.295c-2.157 1.397-4.694 3.373-6.064 4.467a2.36 2.36 0 0 0-.64 2.918 2.36 2.36 0 0 0 2.714 1.246c1.587-.406 4.315-1.141 6.611-1.936l.01 6.01H8.001a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2h-2.988l-.01-6.009c2.294.795 5.021 1.528 6.608 1.935q.3.076.597.076c.883 0 1.705-.494 2.118-1.322a2.36 2.36 0 0 0-.64-2.917zm-1.15 2.026a.37.37 0 0 1-.428.2c-1.873-.479-5.367-1.423-7.737-2.361a1 1 0 0 0-.736 0c-2.37.938-5.864 1.882-7.736 2.361a.376.376 0 0 1-.429-.201.37.37 0 0 1 .098-.463c1.425-1.139 4.138-3.25 6.291-4.598a1 1 0 0 0 .464-.75c.247-2.535.927-5.901 1.31-7.682.074-.346.667-.346.741 0 .383 1.781 1.062 5.147 1.31 7.682.03.309.202.586.464.75 2.153 1.348 4.866 3.459 6.291 4.598a.37.37 0 0 1 .098.463z"
    />
  </svg>
);
export default SvgFiRrWindTurbine;
